import { match } from 'ts-pattern';
import { PowderCoatType } from '../__generated/model/index.js';
import { round } from '../util/round.js';
export var PricingType;
(function(PricingType) {
    PricingType["Dealer"] = "dealer";
    PricingType["Retail"] = "retail";
})(PricingType || (PricingType = {}));
export const getCurrentUserPrice = (pricingItem, options)=>{
    if (!pricingItem) {
        return 0;
    }
    const basePrice = options.userType === 'dealer' ? pricingItem.dealerPrice : pricingItem.retailPrice;
    const swatchPrice = options.includeSwatchUpcharge ? basePrice * cabinetPowderCoatingUpcharge[PowderCoatType.Swatch] : 0;
    const pulsePrice = options.includePulseUpcharge ? basePrice * cabinetPowderCoatingUpcharge[PowderCoatType.Pulse] : 0;
    const powderCoatingPrice = match(options.powderCoatType).with(PowderCoatType.Anvil, ()=>0).with(PowderCoatType.Swatch, ()=>swatchPrice).with(PowderCoatType.Pulse, ()=>swatchPrice + pulsePrice).exhaustive();
    return round(basePrice + powderCoatingPrice, 2);
};
export const getPriceString = (value)=>new Intl.NumberFormat('en', {
        style: 'currency',
        currency: 'USD'
    }).format(value);
export const cabinetPowderCoatingUpcharge = {
    [PowderCoatType.Anvil]: 0,
    [PowderCoatType.Swatch]: 0.1,
    // Pulse upcharge should also incude Swatch upcharge
    // Total upcharge is 0.35
    [PowderCoatType.Pulse]: 0.25
};

//# sourceMappingURL=pricing.js.map